import { useEffect, useState } from 'react';
import Image from "next/image";
import { Form } from "react-bootstrap";
import { useTranslations } from 'next-intl';

import styles from "@/styles/item.module.scss";
import { formatCurrency, modifiersFilter, removeSpacesFromString } from '_services/common.service';
import { Minus, Plus, X } from 'react-feather';
import { Modifier, ModifierOption } from '../pages/itemview';
import CustomTooltip from '../common/customtooltip';
import RemoveCustomizeConfirmation from './remove-customize-confirmation';

export default function CustomizeSelector({ 
    isHalfAndHalf,
    isBottomSheet = false,
    isShowDietaryOptions = false,
    showCustomize, 
    modifiers = [],
    setModifiers,
    totalPrice,
    setShowCustomize,
    handleModifierChange,
    resetModifiers
}: {
    isHalfAndHalf: boolean;
    isBottomSheet: boolean;
    isShowDietaryOptions: boolean;
    showCustomize: boolean;
    modifiers?: Modifier[];
    setModifiers: (modifiers: Modifier[]) => void;
    totalPrice?: string;
    setShowCustomize: (show: boolean) => void;
    handleModifierChange: (optionId: string, index: number, isQuantityChange: boolean, quantityChange: unknown, isHalfAndHalf: boolean) => void;
    resetModifiers?: () => void;
}) {
  const t = useTranslations();
  const [activeTab, setActiveTab] = useState(0);
  // console.log(modifiers);

  // useEffect(() => {
  //   // Reset active tab when modal is opened
  //   if (showCustomize) {
  //     setActiveTab(0);
  //     const existModifiers = structuredClone(modifiers);
  //     console.log(existModifiers);
  //   }
  // }, [showCustomize]);

  const [existModifiers, setExistModifiers] = useState<Modifier[] | null>(null);
  const [showRemoveCustomizeConfirmation, setShowRemoveCustomizeConfirmation] = useState(false);
  const [isReset, setIsReset] = useState(false);


  useEffect(() => {
    if (showCustomize) {
      setActiveTab(0);
      setIsReset(false);

      const clone = structuredClone(modifiers);
      setExistModifiers(clone);
      // console.log("Saved modifiers:", clone);
    }
  }, [showCustomize]);

  const handleModelClose = () => {
    setShowCustomize(false);

    if (
      existModifiers &&
      JSON.stringify(modifiersFilter((existModifiers || []), (isShowDietaryOptions ? ['dietary', 'notdietary'] : ['notdietary']))) === JSON.stringify(modifiersFilter((modifiers || []), (isShowDietaryOptions ? ['dietary', 'notdietary'] : ['notdietary'])))
    ) {
      // console.log("They match!");
    } else  {
      // console.log("They changed!");
      // console.log(existModifiers);
      // console.log("isReset",isReset);
      if(!isReset) {
        setShowRemoveCustomizeConfirmation(true);
      }

      // setModifiers([...existModifiers as Modifier[]]);
    }
  };

  

  return (<>
    <div className={(showCustomize ? (styles.bottomSheetBackdrop + ' ' + styles.showBottomSheetBackdrop) : styles.bottomSheetBackdrop)}></div>

      {showCustomize? <div className={styles.customBackDrop} /> : <></>}

      <div className={`${styles.bottomSheet} ${showCustomize ? styles.show : ''} ${isBottomSheet ? styles.customBottomSheet : ''}`}>
        <div className={styles.overlay} onClick={() => setShowCustomize(false)} />
        <div className={styles.bottomSheetContent}>
          <div className={styles.bottomSheetCloseSection}>
            <div className={styles.customizeBackButton} id="customize-Close" onClick={() => setShowCustomize(false)}><X/></div>
            <div className={styles.bottomSheetHandle} id="customize-handle" onClick={() => setShowCustomize(false)}></div>
          </div>

          <div className={styles.bottomSheetHeader}>
            <h3>{t('ItemView.CUSTOMIZE_TITLE')}</h3>
            <button id="customize-reset-button" className={styles.resetButton} onClick={() => { resetModifiers?.(); setIsReset(true); }}>{t('ItemView.RESET')}</button>
          </div>

          <div className={styles.tabContainer}>
            {modifiers && modifiers.length > 0 && modifiersFilter((modifiers || []), ( isShowDietaryOptions ? ['dietary', 'notdietary'] : ['notdietary'])).map((tab, index) => (
              <button
                id={`customize-tab-${index}`}
                key={ index }
                data-modifiertab={removeSpacesFromString((tab?.modifierName || ''))}
                className={`${styles.tabButton} ${activeTab === index ? styles.activeTab : ''}`}
                onClick={() => setActiveTab(index)}
              >
                <CustomTooltip
                  placement="top"
                  overlayContent={tab?.modifierName ?? ''}
                  scrollElement={document.getElementById('customize-tab-container')}
                >
                  <span>{tab?.modifierName ?? ''}</span>
                </CustomTooltip>
              </button>
            ))}
          </div>
          
          <div className={styles.tabContent}>

          {modifiers && modifiers.length > 0 && modifiersFilter((modifiers || []), ( isShowDietaryOptions ? ['dietary', 'notdietary'] : ['notdietary'])).map((modifier, index) => (
              <div key={index} id={`customize-mod-${index}`} className={`${styles.optionTabPane} ${activeTab === index ? styles.activeTab : ''}`}>
                <h4 className={styles.sectionTitle}>{modifier?.modifierName || 'Unknown'}</h4>
                <div className={styles.optionsGrid}>
                    {modifier?.mofireOptions && [...modifier.mofireOptions]
                    .map((option, originalIndex) => ({ ...option, originalIndex }))
                    .sort((a, b) => (a.isSoldOut === b.isSoldOut ? 0 : a.isSoldOut ? 1 : -1))
                    .map((option: ModifierOption & { originalIndex: number }, optionIndex: number) => (
                    <div key={optionIndex} 
                      id={`customize-mod-${index}-option-${optionIndex}`}
                      onClick={() => {
                        // If single selection and option is sold out, do nothing
                        if(option.isSoldOut && modifier.selectionType === "SINGLE") return;

                        handleModifierChange(modifier.modifierId, option.originalIndex, false, (option.isSoldOut? false : !option.isApplied), isHalfAndHalf)
                      }}
                      className={styles.optionCard + ' ' + (option.isSoldOut ? styles.soldOutCard : '')} 
                      style={{ justifyContent: modifier?.allowQuantities ? 'space-between' : 'flex-start' }}
                      data-modifieroption={removeSpacesFromString((option?.optionName || ''))}
                      >
                      <div className={styles.optionInfo} style={{ display: 'flex', alignItems: 'center', gap: '1rem' }}>
                      <div className={styles.optionImageWrapper}>
                        <Form.Check 
                        type={modifier?.selectionType === "MULTIPLE"?"checkbox":"radio"}
                        id={`option-${index}-${optionIndex}`}
                        name={`modifier-${index}`}
                        className={styles.optionCheckbox}
                        checked={option.isApplied || false}
                        // disabled={option?.isSoldOut}
                        onChange={() => {}}
                        />
                        <Image 
                        src={option.optionImageUrl?.imageUrl || '/assets/images/ingredient.png'}
                        alt={option.optionName}
                        width={55} 
                        height={55}
                        className={styles.optionImage}
                        placeholder='blur'
                        blurDataURL="/assets/images/placeholder.png"
                        />
                      </div>

                      {option.optionName?.length > 25 ? (
                        <CustomTooltip
                        placement="top"
                        overlayContent={option.optionName}
                        scrollElement={document.getElementById(`customize-mod-${index}`)}
                        >
                        <span className={styles.optionName}>
                          {option.optionName.substring(0, 25) + (option.optionName?.length > 25 ? '...' : '')}
                          {!option?.isSoldOut && option?.optionPrice?.amount ? ` (+${formatCurrency((option?.optionPrice?.amount || 0), (option?.optionPrice?.currency || 'USD'))})` : ''}
                          {option?.isSoldOut && <span className={styles.soldOutLabel}>{t('ItemView.SOLD_OUT')}</span>}
                        </span>
                        </CustomTooltip>
                      ) : (
                        <span className={styles.optionName}>
                        {option.optionName.substring(0, 25) + (option.optionName?.length > 25 ? '...' : '')}
                        {!option?.isSoldOut && option?.optionPrice?.amount ? ` (+${formatCurrency((option?.optionPrice?.amount || 0), (option?.optionPrice?.currency || 'USD'))})` : ''}
                        {option?.isSoldOut && <span className={styles.soldOutLabel}>{t('ItemView.SOLD_OUT')}</span>}
                        </span>
                      )}
                      </div>

                      {(modifier?.allowQuantities && option.isApplied) &&<div className={styles.quantityControl}>
                      <button className={styles.quantityButton} 
                        id={`customize-mod-${index}-option-${optionIndex}-minus`}
                        onClick={(e) => {
                        e.stopPropagation();
                        handleModifierChange(modifier.modifierId, optionIndex, true, -1, isHalfAndHalf)}
                        }>
                        <Minus size={14} />
                      </button>
                      <span>{(parseInt(option?.quantity.toString() || '1') > 0 ? option?.quantity : 1)}</span>

                      <button className={styles.quantityButton} 
                        id={`customize-mod-${index}-option-${optionIndex}-plus`}
                        onClick={(e) => {
                        e.stopPropagation();
                        handleModifierChange(modifier.modifierId, optionIndex, true, 1, isHalfAndHalf);
                        }}>
                        <Plus size={14} />
                      </button>
                      </div>}

                    </div>
                    ))}
                </div>
              </div>
            ))}

            {/* {activeTab === 'Sauces' && (
              
            )}
            {activeTab === 'Add Ons' && (
              <div className={styles.addOnsGrid}>
                {addOns.map((addOn) => (
                  <div key={addOn} className={styles.addOnCard}>
                    <div className={styles.addOnContent}>
                      <Form.Check 
                        type="checkbox"
                        id={`add-on-${addOn}`}
                        label={addOn}
                        className={styles.addOnCheckbox}
                        />
                    </div>
                    
                    <div className={styles.quantityControl}>
                      <button className={styles.quantityButton}>
                        <Minus
                          size={14} />
                      </button>
                      <span>1</span>
                      <button className={styles.quantityButton}>
                        <Plus size={14} />
                      </button>
                    </div>
                  </div>
                ))}
              </div>
            )}
            {activeTab === 'Ingredients' && (
              <>
                <h4 className={styles.sectionTitle}>Remove Unwanted Ingredients</h4>
                <div className={styles.ingredientsGrid}>
                  {ingredients.map((ingredient, index) => (
                    <div key={index} className={styles.ingredientCard}>
                      <div className={styles.ingredientContent}>

                        <Form.Check
                          type="checkbox"
                          id={`ingredient-${index}`}
                          className={styles.ingredientCheckbox}
                        />

                        <Image 
                          src={ingredient.image}
                          alt={ingredient.name}
                          width={55} 
                          height={55}
                          className={styles.ingredientImage}
                        />
                        <span className={styles.ingredientName}>{ingredient.name}</span>
                      </div>
                    </div>
                  ))}
                </div>
              </>
            )} */}
          </div>
          <div className={styles.bottomSheetFooter}>
            {/* <button className={styles.cancelButton} onClick={() => {setShowCustomize(false)}}>{t('ItemView.CLOSE')}</button> */}
            <button className={styles.cancelButton} onClick={handleModelClose}>{t('ItemView.CLOSE')}</button>
            <button 
              id="customize-update-button"
              onClick={() => setShowCustomize(false)} 
              className={styles.updateButton}>{t('common.update')} ({totalPrice})</button>
          </div>
        </div>
        {/* <div className={styles.overlay} onClick={() => setShowCustomize(false)}></div> */}
    </div>

    <RemoveCustomizeConfirmation
      show={showRemoveCustomizeConfirmation}
      onClose={() => setShowRemoveCustomizeConfirmation(false)}
      onConfirm={() => {
        setModifiers([...existModifiers as Modifier[]]);
        setShowRemoveCustomizeConfirmation(false)
      }}
    />
  </>);
}